import UploadedMomentsListItem from './UploadedMomentsListItem';

const UploadedMomentsList = ({
  moments
}: {
  moments: { tempId: string; filename: string; isUploading: boolean }[];
}) => (
  <div>
    <div className="text-[14px] text-gray-500 font-normal">
      {moments.length} moments uploaded
    </div>
    <div className="mt-4">
      {moments.map((moment) => (
        <UploadedMomentsListItem
          key={moment.tempId}
          filename={moment.filename}
          isUploading={moment.isUploading}
        />
      ))}
    </div>
  </div>
);

export default UploadedMomentsList;
